import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import axios from "axios";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import { Events } from "@/events/events";
import ItemsMatching from "@/components/itemsMatching/ItemsMatching.vue";
import ItemsSorting from "@/components/itemsSorting/ItemsSorting.vue";
import quizUtils from "@/util/quizUtils";
import QuizUtils from "@/util/quizUtils";
let SortingQuestionEdit = class SortingQuestionEdit extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "chapterId", void 0);
    _defineProperty(this, "questionId", void 0);
    _defineProperty(this, "question", null);
    _defineProperty(this, "sortingItems", []);
  }
  mounted() {
    this.loadQuestionData();
  }
  /**
   * load question data by the questionId
   * @private
   */
  loadQuestionData() {
    axios.get(`${quizUtils.QUIZ_QUESTION_BASE_API}/${this.questionId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.handleLoadedSortingData(response.data);
    }).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    });
  }
  handleLoadedSortingData(loadedQuestion) {
    this.question = loadedQuestion;
    if (!!this.question?.sortingItems?.length) {
      this.sortingItems = this.question.sortingItems.map(sortingItem => ({
        id: sortingItem.id,
        position: sortingItem.position,
        value: sortingItem.value,
        image: sortingItem.image
      }));
    } else {
      this.addSortingItems(2);
    }
  }
  addSortingItems(nbItems = 1) {
    for (let i = 0; i < nbItems; i++) {
      this.sortingItems = [...this.sortingItems, {
        position: this.sortingItems.length + 1,
        value: ''
      }];
    }
  }
  /**
   * on sorting items update, save the data
   * @param items
   */
  onSortingItemsUpdate(items) {
    this.sortingItems = items;
    if (this.atLeastTwoSortingItemsItemsAreSet(items)) {
      this.saveSortingItems(items);
    }
  }
  /**
   * save pairs
   * @param pairs
   * @private
   */
  saveSortingItems(pairs) {
    const validItems = this.getSortingItemsToSave(pairs);
    if (validItems.length) {
      axios.put(`${quizUtils.QUIZ_QUESTION_BASE_API}/${this.questionId}/sorting-data`, {
        sortingItemsJson: JSON.stringify(validItems)
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        WElMessage.showSuccessMessage(this.$t('chapter.question.answerModification.success'));
        this.handleLoadedSortingData(response.data);
        trig(Events.NEW_KIND_OF_QUESTION_UPDATED, {
          chapterId: this.chapterId,
          questionId: this.questionId
        });
      }).catch(() => {
        WElMessage.showErrorMessage(this.$t('errors.default'));
      });
    }
  }
  /**
   * Get extract sorting items to save.
   * @param sortingItems
   * @private
   */
  getSortingItemsToSave(sortingItems) {
    const validItems = structuredClone(sortingItems).filter(item => this.itemIsValid(item));
    validItems.sort((a, b) => a.position - b.position);
    validItems.forEach((item, index) => {
      item.position = index + 1;
      delete item.isValueError;
    });
    return validItems;
  }
  /**
   * verifier si au moins deux items sont bien renseignés
   * @private
   */
  atLeastTwoSortingItemsItemsAreSet(pairs) {
    return pairs.filter(pair => this.itemIsValid(pair)).length >= 2;
  }
  /**
   * verifier si un sorting item est renseigné
   * @param item
   * @private
   */
  itemIsValid(item) {
    return !!item.value || QuizUtils.questionAnswerImageExists(item.image);
  }
};
__decorate([Prop({
  required: true
})], SortingQuestionEdit.prototype, "chapterId", void 0);
__decorate([Prop({
  required: true
})], SortingQuestionEdit.prototype, "questionId", void 0);
SortingQuestionEdit = __decorate([Component({
  components: {
    ItemsSorting,
    ItemsMatching
  }
})], SortingQuestionEdit);
export default SortingQuestionEdit;